<template>
  <DxDataGrid :data-source="searchHistoryItems"
              :row-alternation-enabled="true"
              :remote-operations="true"
              :show-column-headers="false"
              :show-column-lines="false"
              :show-row-lines="false"
              :height="400"
  >
    <DxColumn cell-template="cell-template"/>

    <template #cell-template="{ data: search }">
      <div class="search-history-card"
           @click="setSearchObjects(search.data)"
      >
        <span> {{ new Date(search.data.updated_at).toLocaleString('en-US') }} </span>
        <div class="search-container">
          <div class="dx-tag-content" v-for="searchObj in search.data.search_params">
            {{ searchObj.text }}
          </div>
        </div>
        <span class="result-count"> {{ search.data.result_count }} results </span>
      </div>
    </template>
  </DxDataGrid>
</template>

<script setup>
  import { storeToRefs } from "pinia";
  import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";

  const searchPageStore = useSearchPageStore()
  const { searchHistoryItems, searchBarObjects } = storeToRefs(searchPageStore)

  const setSearchObjects = (searchData) => searchBarObjects.value = searchData.search_params
</script>

<style scoped lang="scss" >
  .search-history-card {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;

    .search-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .dx-tag-content {
      padding-right: 6px;
    }

    .result-count {
      align-self: flex-end;
    }
  }
</style>
